import { ETIQUETA_REGERAR } from "../actions/etiqueta";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {};

const getters = {};

const actions = {
  [ETIQUETA_REGERAR]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.etiqueta
        .regerarEtiquetas(getters.getFornecedorId, payload)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
